export enum DurationUnits {
    all='All',
    threeMonths='3 Months',
    sixMonths='6 Months',
    tweleveMonths='12 Months',
    lastBillingPeriod='Last Billing Period',
    threeBillingPeriod='3 Billing Periods',
    sixBillingPeriod='6 Billing Periods',
    twelveBillingPeriod='12 Billing Periods'
}

export enum Partners {
 microsoft='Microsoft',
 partner= 'Partner',
 microsoftNonCSP='MicrosoftNonCSP',
}